// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../css-loader/index.js!../../../../vue-loader/lib/loaders/stylePostLoader.js!../../../../sass-loader/dist/cjs.js!../../../../vue-loader/lib/index.js??vue-loader-options!./Sucker.vue?vue&type=style&index=0&lang=scss&");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("6e860136", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../css-loader/index.js!../../../../vue-loader/lib/loaders/stylePostLoader.js!../../../../sass-loader/dist/cjs.js!../../../../vue-loader/lib/index.js??vue-loader-options!./Sucker.vue?vue&type=style&index=0&lang=scss&", function() {
     var newContent = require("!!../../../../css-loader/index.js!../../../../vue-loader/lib/loaders/stylePostLoader.js!../../../../sass-loader/dist/cjs.js!../../../../vue-loader/lib/index.js??vue-loader-options!./Sucker.vue?vue&type=style&index=0&lang=scss&");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}